import type { PropsWithChildren } from 'react';

import styles from './Footer.module.scss';

export function Footer({ children }: PropsWithChildren) {
  return <div className={styles.footer}>{children}</div>;
}